// Where the marketing site links.
export const CONTACT_EMAIL = 'hello@righthanddms.com';
export const AUDIENCES = [
    'dealer',
    'individual'
];
/** ?for= on /request-access → the audience it preselects (null: not given or not one of ours). */ export function audienceFrom(search) {
    const v = new URLSearchParams(search).get('for');
    return v === 'dealer' || v === 'individual' ? v : null;
}
export const MKT = {
    home: '/',
    login: '/login',
    requestAccess: '/request-access',
    /** The request-access form with who's asking already chosen. */ requestAccessFor: (a)=>`/request-access?for=${a}`,
    bookCall: '/request-access?for=dealer#call',
    signup: '/signup',
    /** Sign-up with who's signing up already chosen. */ signupFor: (a)=>`/signup?for=${a}`,
    forDealers: '/for-dealers',
    importMyOwn: '/import-my-own',
    /** The dealer website add-on and its theme previews. */ dealerWebsites: '/dealer-websites',
    /** The audience's own page. */ audience: (a)=>a === 'dealer' ? '/for-dealers' : '/import-my-own',
    /** The pricing page open on the audience's tab. */ pricingFor: (a)=>a === 'dealer' ? '/pricing#dealer' : '/pricing#import-my-own',
    guide: '/guide',
    pricing: '/pricing',
    faq: '/faq',
    security: '/security',
    terms: '/terms',
    blog: '/blog',
    product: (slug)=>`/product/${slug}`
};
/**
 * Official pages for the legal and regulatory questions the marketing pages don't answer
 * themselves. Checked to resolve (2026-10-17); NHTSA refuses automated checks, so open it by hand
 * when re-checking.
 */ export const OFFICIAL = {
    cbp: {
        name: 'CBP: Importing a motor vehicle',
        href: 'https://www.cbp.gov/trade/basic-import-export/importing-car'
    },
    epa: {
        name: 'EPA: Importing vehicles and engines',
        href: 'https://www.epa.gov/importing-vehicles-and-engines'
    },
    nhtsa: {
        name: 'NHTSA: Importing a vehicle',
        href: 'https://www.nhtsa.gov/importing-vehicle'
    },
    dmv: {
        name: 'USA.gov: your state’s motor vehicle office',
        href: 'https://www.usa.gov/state-motor-vehicle-services'
    }
};
/** The two audience pages, as the nav, footer and home hero name them. */ export const AUDIENCE_PAGES = {
    dealer: {
        k: '商',
        name: 'For dealers',
        line: 'Sourcing for customers, stock and margin'
    },
    individual: {
        k: '個',
        name: 'Import my own',
        line: 'Bring in one JDM car or truck for yourself'
    }
};
export const PRODUCTS = [
    {
        slug: 'search',
        k: '検索',
        name: 'Auction search',
        line: 'One search across your agent accounts'
    },
    {
        slug: 'auction-sheets',
        k: '査定',
        name: 'Auction sheets',
        line: 'Japanese sheets read into plain English'
    },
    {
        slug: 'pricing-guidance',
        k: '相場',
        name: 'Pricing guidance',
        line: 'Bid ranges from real sold lots'
    },
    {
        slug: 'hunts',
        k: '探索',
        name: 'Hunts & custom orders',
        line: 'Standing searches for you or a customer'
    },
    {
        slug: 'bidding',
        k: '入札',
        name: 'Bidding & wins',
        line: 'Watch, bid, won, with one record per car'
    },
    {
        slug: 'landed-cost',
        k: '原価',
        name: 'Landed cost',
        line: 'Real cost per car, from your paperwork'
    },
    {
        slug: 'email',
        k: '郵便',
        name: 'Email: Fastmail & IMAP',
        line: 'Your mailbox, drafts first'
    }
];
